import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from '@/components/Modal'
import { BaseView, BaseText } from '@/components/base'
import useOffsets from '@/hooks/useOffsets'

interface NoteModalProps {
  isOpen: boolean
  onClose: () => void
  note: string
  subjectFullName?: string
}

export const NoteModal: React.FC<NoteModalProps> = ({
  isOpen,
  onClose,
  note,
  subjectFullName,
}) => {
  const { t } = useTranslation()
  const offsets = useOffsets()

  return (
    <Modal isOpen={isOpen} onClose={onClose} showHandle={true}>
      <BaseView
        style={{
          gap: 25,
          paddingBottom: offsets.bottom,
        }}
      >
        <BaseText
          fontSize={20}
          fontFamily="semibold"
          color="label.default"
          style={{
            textAlign: 'center',
          }}
        >
          {t('translation:noteFrom')} {subjectFullName}
        </BaseText>

        <BaseView>
          <BaseText
            fontSize={16}
            fontFamily="regular"
            color="label.description"
            style={{
              textAlign: 'center',
              lineHeight: '24px',
              whiteSpace: 'pre-wrap',
            }}
          >
            {note}
          </BaseText>
        </BaseView>
      </BaseView>
    </Modal>
  )
}
